import { PivotControls as W } from "@react-three/drei";
import { memo as y, useMemo as T, useCallback as s, useEffect as k, useLayoutEffect as z } from "react";
import { Matrix4 as G } from "three";
import H from "zustand";
import { useRefPersistent as J } from "../../hooks/index7.js";
import { DecomposeMatrix as K } from "../../utils/index6.js";
import { MatrixToPosition as N } from "../../utils/index20.js";
import { MatrixToRotationV3 as P } from "../../utils/index21.js";
import { PlaneFC as Q } from "../plane-fc/index.js";
import { PointDeleteBtn as U } from "../point-list-editor/index.js";
import { jsxs as j, Fragment as X, jsx as g } from "react/jsx-runtime";
function Y({
  list: d,
  orbit: A,
  readonly: l,
  Component: D,
  addOnDbClick: E,
  onChange: w,
  onDelete: b,
  onAdd: L,
  onSelect: u,
  dbClickDistTolerance: p = 0.01,
  ...S
}) {
  const c = J({
    onAdd: L,
    onSelect: u,
    onChange: w,
    onDelete: b,
    list: d,
    orbit: A,
    addOnDbClick: E,
    dbClickDistTolerance: p
  }), v = T(() => H(() => ({})), []), {
    getState: r,
    setState: n
  } = v, i = v(), _ = T(() => d.map(K), [d]), f = i.selected !== void 0 ? d[i.selected] : void 0, q = s((t, e, o, m) => {
    const {
      onChange: x
    } = c(), {
      initialMx: a,
      selected: M
    } = r();
    if (!x || !a || M === void 0)
      return;
    const h = a.clone().premultiply(m);
    n({
      currentMx: h.clone()
    }), x(M, h);
  }, []), O = s(() => {
    const {
      orbit: t,
      list: e
    } = c(), {
      selected: o
    } = r();
    t && (t.enabled = !1), n({
      dragging: !0,
      initialMx: e[o]
    });
  }, []), R = s(() => {
    const {
      orbit: t,
      list: e
    } = c(), {
      selected: o
    } = r();
    t && (t.enabled = !0), n({
      dragging: !1,
      initialMx: r().currentMx || e[o],
      currentMx: void 0
    });
  }, []), F = s(() => {
    const {
      onDelete: t
    } = c(), {
      selected: e
    } = r();
    !t || e !== void 0 && (n({}, !0), t(e));
  }, []), B = s((t) => {
    const {
      selected: e
    } = r();
    setTimeout(() => {
      const {
        selected: o
      } = r();
      o === e && (o === void 0 ? C(t) : n({}, !0));
    }, 0);
  }, []), C = s((t, e) => {
    const {
      selected: o,
      lastAdded: m
    } = r(), {
      addOnDbClick: x,
      onAdd: a
    } = c();
    if (o !== void 0 || x && !e || !a)
      return;
    const M = p * p;
    m && m.distanceToSquared(t) < M || (n({
      lastAdded: t.clone()
    }), a(new G().setPosition(t)));
  }, []), I = s((t) => {
    setTimeout(() => {
      C(t, !0);
    }, 0);
  }, []), V = s((t) => {
    const e = t.eventObject.userData.index, {
      list: o
    } = c();
    n({
      selected: e,
      initialMx: o[e]
    });
  }, []);
  return k(() => {
    u && u(i.selected);
  }, [i.selected, u]), k(() => {
    l && n({}, !0);
  }, [l]), z(() => {
    if (!f || i.dragging || i.initialMx && i.initialMx.equals(f))
      return;
    const t = setTimeout(() => n({
      initialMx: f.clone()
    }), 1e3);
    return () => clearTimeout(t);
  }, [f, i.dragging, i.initialMx]), /* @__PURE__ */ j(X, {
    children: [!l && i.selected !== void 0 && i.initialMx && /* @__PURE__ */ g(W, {
      anchor: [0, 0, 0],
      fixed: !0,
      depthTest: !1,
      scale: 75,
      lineWidth: 2,
      ...S,
      onDrag: q,
      onDragStart: O,
      onDragEnd: R,
      rotation: P(i.initialMx),
      children: /* @__PURE__ */ j("object3D", {
        position: N(i.initialMx),
        rotation: P(i.initialMx),
        children: [D, b && /* @__PURE__ */ g(U, {
          onClick: F
        })]
      })
    }, i.selected + i.initialMx.toArray().join("|")), _.map((t, e) => /* @__PURE__ */ g("object3D", {
      userData: {
        index: e
      },
      onClick: l ? void 0 : V,
      ...t,
      children: i.selected !== e && D
    }, e)), !l && /* @__PURE__ */ g(Q, {
      onClick: B,
      onDoubleClick: I
    })]
  });
}
const at = y(Y);
export {
  at as TransformListEditor
};
//# sourceMappingURL=index.js.map
